@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.CalanderDivStyle {
  @extend %font-family-primary;

  background: $theme-color-background; // So the component will not have transparent background
  box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;
  border-radius: 6px;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 1em;
  z-index: 999 !important;
}
